<template>
  <v-dialog
    :model-value="isOpen"
    fullscreen
    @update:model-value="updateDialog"
  >
    <v-card>
      <v-toolbar color="primary">
        <v-btn
          icon
          variant="text"
          aria-label="Zapri pregled slike"
          @click="close"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ currentImage.alt }}</v-toolbar-title>
      </v-toolbar>

      <v-carousel
        v-if="images.length"
        :model-value="currentIndex"
        height="calc(100vh - 64px)"
        hide-delimiters
        show-arrows="hover"
        @update:model-value="selectImage"
      >
        <v-carousel-item
          v-for="image in images"
          :key="image.name"
          :src="image.name"
          :alt="image.alt || 'Slika'"
        />
      </v-carousel>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MaterialLightbox',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'select'],
  data() {
    return {
      currentIndex: -1,
    };
  },
  computed: {
    isOpen() {
      return Boolean(this.modelValue && this.currentIndex >= 0);
    },
    currentImage() {
      return this.images[this.currentIndex] || { alt: 'Slika', name: '' };
    },
  },
  watch: {
    images: {
      handler() {
        this.syncCurrentIndex();
      },
      deep: true,
    },
    modelValue: {
      handler() {
        this.syncCurrentIndex();
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    selectImage(index) {
      this.currentIndex = index;

      const image = this.images[index];
      if (image && image.name !== this.modelValue) {
        this.$emit('select', image.name);
      }
    },
    syncCurrentIndex() {
      const index = this.images.findIndex(image => image.name === this.modelValue);
      this.currentIndex = index;
    },
    updateDialog(open) {
      if (!open) {
        this.close();
      }
    },
  },
};
</script>
